import React from 'react'
import { IconButton, Stack } from '@mui/material'
import { useGlobalState } from 'state'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'

export const ZoomControl = () => {
  const state = useGlobalState()

  const displayZoom = React.useMemo((): string => {
    if (Number.isInteger(Number(state.map.zoom.toFixed(1)))) {
      return state.map.zoom.toFixed(0)
    } else {
      return state.map.zoom.toFixed(1)
    }
  }, [state.map.zoom])

  const handlerClick = (sign: 'plus' | 'minus') => {
    if (!state.mapbox) return
    let num = state.map.zoom
    if (Number.isInteger(Number(num.toFixed(1)))) {
      if (sign === 'plus') {
        num += 1
      } else {
        num -= 1
      }
      num = Math.floor(num)
    } else {
      num = Math.floor(num)
      if (sign === 'plus') {
        num += 1
      }
    }
    state.mapbox.setZoom(num)
  }

  return (
    <Stack alignItems={'flex-end'} sx={{pointerEvents: 'painted'}}>
      <Stack direction={'column'} color={'white'} sx={{backgroundColor: 'rgba(19, 55, 102, 0.7)', width: 30}}>
        <IconButton size='small' color="inherit" onClick={() => handlerClick('plus')}>
          <AddIcon sx={{width: 18, height: 18}} />
        </IconButton>
        <Stack
          justifyContent={'center'}
          alignItems={'center'}
          sx={{
            backgroundColor: 'white',
            color: 'black',
            fontSize: 13,
            height: 24,
          }}
        >
          {displayZoom}
        </Stack>
        <IconButton size='small' color="inherit" onClick={() => handlerClick('minus')}>
          <RemoveIcon sx={{width: 18, height: 18}} />
        </IconButton>
      </Stack>
    </Stack>
  )
}
